import { getContent } from '@plone/volto/actions/content/content';
import { listActions } from '@plone/volto/actions/actions/actions';
import { getBaseUrl, isCmsUi } from '@plone/volto/helpers/Url/Url';

/**
 * Refresh Volto content + CMS actions for a return URL or pathname.
 * Skips non-content routes (e.g. /login).
 */
export function refreshContentActionsForPath(dispatch, pathOrUrl) {
  if (!pathOrUrl || typeof pathOrUrl !== 'string') {
    return;
  }

  const pathname = pathOrUrl.split('?')[0];
  if (isCmsUi(pathname)) {
    return;
  }

  const baseUrl = getBaseUrl(pathname);
  dispatch(listActions(baseUrl));
  dispatch(getContent(baseUrl));
}
